export const addNotification = (notification:any) =>
	({
		type    : 'ADD_NOTIFICATION',
		payload : { notification }
	});

export const removeNotification = (notificationId:string) =>
	({
		type    : 'REMOVE_NOTIFICATION',
		payload : { notificationId }
	});

export const removeAllNotifications = () =>
	({
		type : 'REMOVE_ALL_NOTIFICATIONS'
	});